<template>
  <div id="requests" :class="{'logged':User.token}">

    <NoAccount v-if="!User.token"></NoAccount>

    <template v-if="User.token">

      <div class="tabs" v-if="User.token">
        <div class="tab" :class="{active: filter === 'inProgress'}" @click="setFilter('inProgress')">{{ $t("requests.status.in_progress") }}</div>
        <div class="tab" :class="{active: filter === 'completed'}" @click="setFilter('completed')">{{ $t("requests.status.done") }}</div>
        <div class="filler"></div>
      </div>
      
      <div class="scroll" v-if="User.token">
        <div class="scrollInner">

          <div class="post" v-for="request of requests" @click="toRequest(request.id)" :key="request.id">
            <div class="image">
              <div class="imageContainer">
                <svgicon v-if="$store.state.cogir" src="svg/octo.svg" :height="50" :width="50"></svgicon>
                <svgicon v-if="!$store.state.cogir" src="svg/humaniti.svg" :height="50" :width="50"></svgicon>
              </div>
            </div>
            <div class="middle">
              <v-clamp :max-lines="1" class="title">{{ request.title }}</v-clamp>
              <div class="subtitle">#{{ leftPad(request.id, 7) }}</div>
              <div class="message" >
                {{ $t("date") }} : {{ request.createdAt.format("DD/MM/YYYY - HH:mm") }}<br>
                {{ $t("status") }} : {{ $t("requests.status." + request.status) }}
              </div>
            </div>
            <div class="arrow" v-show="!$store.state.isDesktop">
              <svgicon src="svg/arrow.svg" :width=11 :height=20></svgicon>
            </div>
          </div>

        </div>
      </div>

      <div class="footer" :class="{desktop: $store.state.isDesktop}">

        <div class="btn btn-primary" @click="newRequest" v-if="User.token">{{ $t("requests.new_text") }}</div>

<!--        <div class="pagination" v-show="$store.state.isDesktop">-->
<!--          <div class="page first" @click="" ><div>&lsaquo;&lsaquo;</div></div>-->
<!--          <div class="page previous"  @click=""><div>&lsaquo;</div></div>-->
<!--          <div class="page" @click=""> 1 </div>-->
<!--          <div class="page next"  @click=""><div>&rsaquo;</div></div>-->
<!--          <div class="page last"  @click=""><div>&rsaquo;&rsaquo;</div></div>-->
<!--        </div>-->
      </div>

    </template>


  </div>
</template>

<script>

  import NoAccount from "../components/NoAccount.vue";
  import User from '../../core/User';
  import Requests from "../../core/Requests";
  import Services from "../../core/Services";
  import RequestCategories from "../../core/RequestCategories";

  export default {

    name: "requests",

    components: { NoAccount },

    data() {
      return {
        User,
        Requests,
        RequestCategories,
        CONFIG,
        filter: "inProgress"
      };
    },

    mounted() {
      if(RequestCategories && RequestCategories.categories.length < 1){
        this.$router.push("/home");
      }
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: "menu.requests",
        headerIcon: "/svg/history.svg"
      });
      Requests.init();
    },

    computed: {
      requests() {
        if (this.filter === 'completed') {
          return this.Requests.requests.filter(r => r.isDone());
        }
        return this.Requests.requests.filter(r => !r.isDone());
      },
      category() {
        return id => {
          return Services.get(id);
        }
      }
    },

    methods: {
      newRequest() {
        this.$router.push("/new-request");
      },
      toRequest(id) {
        this.$router.push("/requests/" + id);
      },
      leftPad(str, length) {
        return window.leftPad(str, length, "0");
      },
      setFilter(filter) {
        this.filter = filter;
      },
    }

  }

</script>

<style lang="scss" scoped>

  #requests {
    background-color: #f2f3f4;
    display: flex;
    flex-direction: column;
  }

  .footer {
    padding: 20px;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .pagination {
    display: flex;
    div:not(:last-of-type) {
      margin-right: 10px;
    }

    .page {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: white;
      border-radius: 4px;
      color: #808b91;
      cursor: pointer;
      transition: box-shadow 0.2s ease;
      &:hover {
        box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.1);
      }
      &.active {
        background-color: #808b91;
        color: white;
      }
      &.previous, &.next, &.first, &.last {
        font-size: 32px;
        & > div {
          position: relative;
          top: -4px;
        }
      }
      &.disabled {
        opacity: 0.6;
        pointer-events: none;
      }
    }
  }

  .tabs {
    display: flex;
    color: #808b91;
    flex-shrink: 0;

    .tab {
      height: 40px;
      flex-basis: 0;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &.active {
        font-weight: 500;
      }
    }
  }
  
  .post {
    cursor: pointer;
    background-color: white;
    border-radius: 3px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    display: flex;
    overflow: hidden;
    margin-bottom: 4px;
    &:not(:last-of-type) {
      margin-bottom: 20px;
    }
    
    .image {
      min-height: 100px;
      width: 100px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #405159;
      fill: #001722;
      .imageContainer {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
      }
      img {
        max-width: 60px;
        max-height: 60px;
      }
    }
    .middle {
      flex-grow: 1;
      padding: 10px 6px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .subtitle {
        color: #808b91;
        font-size: 12px;
        margin-bottom: 10px;
      }
      .message {
        color: #405159;
        font-size: 14px;
      }
      .title {
        word-break: break-all;
        font-weight: 500;
      }
    }
    .arrow {
      width: 30px;
      background-color: #f2f3f4;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      .svgicon {
        fill: #808b91;
      }
    }
  }

  .scroll {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    flex-grow: 1;
    padding: 20px;
  }

  /* MOBILE ONLY RULES */
  @media screen and (max-width: 600px) {

    .tabs {
      background-color: #001722;
      border-top: 1px solid #405159;
      .tab {
        flex-grow: 1;
        &.active {
          color: white;
          font-weight: bold;
          box-shadow: inset 0 -4px #405159;
        }
      }
    }

    .post {
      .image {
        min-height: 100px;
        width: 100px;
      }
      .middle {
        padding: 10px 10px;
        .subtitle {
          font-size: 12px;
          margin-bottom: 10px;
        }
        .message {
          font-size: 14px;
        }
      }
      .arrow {
        width: 30px;
        background-color: #f2f3f4;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        .svgicon {
          fill: #808b91;
        }
      }
    }

    .btn {
      flex-grow:1;
    }
    
    .filler {
      display: none;
    }
  }

  /* DESKTOP ONLY RULES */
  @media screen and (min-width: 601px) {
    #requests{
      &.logged {
        padding: 30px 60px 30px 60px;
      }
      
      &:not(.logged) {
        display:flex;
        flex-direction: row;
        justify-content: center;
        align-items:baseline;
      }
      
    }

    .tabs {
      background-color: #f2f3f4;
      margin-bottom: 30px;
      .filler {
        flex-grow: 1;
        border-bottom: 5px solid #e6e6e6;
      }

      .tab {
        min-width:175px;
        padding: 0 18px;
        font-size: 16px;
        line-height: 1;
        text-align: center;
        text-decoration: none;
        border-bottom: 5px solid #e6e6e6;
        transition: border-bottom-color 0.2s ease-in-out;
        color: #808080;
        &.active, &.router-link-active {
          color: #404040;
          font-weight: 500;
          border-bottom: 5px solid #808b91;
          cursor: auto;
        }
        &:hover {
          border-bottom: 5px solid #808b91;
        }
        &.disabled {
          color: rgba(128, 128, 128, 0.4);
          pointer-events: none;
        }
      }
    }
    
    .scroll {
      padding: 0;

      .scrollInner {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
      }

      .post {
        margin: 0 30px 20px 30px;
        flex-grow: 1;
        flex-basis: 0;
        flex-shrink: 0;
        min-width: 450px;
        //max-width: 720px;
        .image {
          min-height: 140px;
          width: 140px;
        }
        .middle {
          font-size: 20px;
          padding: 10px 30px;
          .subtitle {
            font-size: 14px;
            margin-bottom: 16px;
          }
          .message {
            font-size: 16px;
          }
        }
      }
      
      .filler {
        background:none;
        box-shadow: none;
        margin-bottom:0;
      }
    }

    .footer {
      padding:20px 0;
      
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .btn-primary{
        min-width:180px;;
      }
    }
  }

</style>